/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { getTopologyRoomData } from "../multiplayer/SocketConnection";
import {
    DELAY_ANALISYS_ROOM,
    EXPLORE_ROOM,
    HOME_ROOM,
    JOB_ROOM,
    TOPOLOGY_ROOM,
    WORKSTATION_ROOM,
} from "../rooms/RoomNameConstants";
import { loadRemoteCenterGraph } from "../store/slice/centerGraphSlice";
import { loadRemoteHistory } from "../store/slice/roomSlice";
import { loadRemoteDelayAnalysisRoom } from "../store/slice/roomSlices/delayAnalysisRoomSlice";
import { loadRemoteExploreRoom } from "../store/slice/roomSlices/exploreRoomSlice";
import { loadRemoteHomeRoom } from "../store/slice/roomSlices/homeSlice";
import { loadRemoteJobRoom } from "../store/slice/roomSlices/jobRoomSlice";
import { laodRemoteTopologyRoom } from "../store/slice/roomSlices/topologyRoomSlice";
import { loadRemoteWorkstationRoom } from "../store/slice/roomSlices/workstationRoomSlice";
import { loadRemoteEnginesStack } from "../store/slice/userSlice";
import store from "../store/store"

export const updateCurrentRoom = (data) => {
    const { id, history, centerGraph, enginesStack } = data;
    const dispatch = store.dispatch;
    
    dispatch(loadRemoteHistory(history));
    dispatch(loadRemoteEnginesStack(enginesStack));

    let roomName
    history.forEach((h) => {
        roomName = h.ID
        switch (roomName) {
            case HOME_ROOM:
                dispatch(loadRemoteHomeRoom(data[roomName]));
                break;
            case JOB_ROOM:
                dispatch(loadRemoteJobRoom(data[roomName]));
                getTopologyRoomData({
                    selectedJob: data[roomName].selectedJob,
                    targetRoom: TOPOLOGY_ROOM
                })
                break;
            case WORKSTATION_ROOM:
                dispatch(loadRemoteWorkstationRoom(data[roomName]));
                break;
            case EXPLORE_ROOM:
                dispatch(loadRemoteExploreRoom(data[roomName]));
                break;
            case TOPOLOGY_ROOM:
                dispatch(laodRemoteTopologyRoom(data[roomName]));
                break;
            case DELAY_ANALISYS_ROOM:
                dispatch(loadRemoteDelayAnalysisRoom(data[roomName]));
                break;
    
            default:
                console.log("not knowed room from server")
                break;
        }
    });

    switch (id) {
        case HOME_ROOM:
            dispatch(loadRemoteCenterGraph(centerGraph));
            break;
        case JOB_ROOM:
            dispatch(loadRemoteCenterGraph(centerGraph));
            break;
        case WORKSTATION_ROOM:
            dispatch(loadRemoteCenterGraph(centerGraph));
            break;
        case EXPLORE_ROOM:
            dispatch(loadRemoteCenterGraph(centerGraph));
            break;

        default:
            console.log("not knowed room from server")
            break;
    }
}